import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import Lottie, { LottieComponentProps } from 'lottie-react'

import { Rocket } from '@/assets/images/logo'
import conversation from '@/assets/lottie/conversation.json'
import howitworks from '@/assets/lottie/howitworks.json'
import litterfire from '@/assets/lottie/litterfire.json'
import betsol from '@/assets/lottie/lott_betsol_logo.json'
import { GitBookLink } from '@/constants/manifast'
import { cn } from '@/lib/utils'
import { RoutePath } from '@/routes'

import { IconTooltip } from '../svgr/common'

import { Flex } from './Box'
import Tooltip from './Tooltip'

export const FileRocket = React.forwardRef<
  React.ComponentRef<typeof Lottie>,
  Omit<LottieComponentProps, 'animationData'> & {
    wrapperClassName?: string
    rocketClassName?: string
    orientation?: 'vertical' | 'horizontal'
  }
>(
  (
    {
      wrapperClassName,
      className,
      rocketClassName,
      orientation = 'horizontal',
      ...props
    },
    ref
  ) => (
    <Lottie
      ref={ref}
      {...props}
      className={cn('h-8 xl:h-12')}
      loop
      animationData={betsol}
    />
  )
  //   (
  //   <Flex
  //     className={cn(
  //       'h-12 items-center gap-2',
  //       orientation === 'vertical'
  //         ? 'animate-floatX flex-col-reverse gap-0'
  //         : 'animate-floatY',
  //       wrapperClassName
  //     )}
  //   >
  //     <Lottie
  //       ref={ref}
  //       {...props}
  //       className={cn(
  //         'w-20',
  //         orientation === 'horizontal' ? '-rotate-90' : '-rotate-180',
  //         className
  //       )}
  //       loop
  //       animationData={litterfire}
  //     />
  //     <img
  //       src={Rocket}
  //       alt="rocket"
  //       className={cn(
  //         'h-full',
  //         orientation === 'horizontal' ? '' : '-rotate-90',
  //         rocketClassName
  //       )}
  //     />
  //   </Flex>
  // )
)

export const ConverSation = React.forwardRef<
  React.ComponentRef<typeof Lottie>,
  Omit<LottieComponentProps, 'animationData'> & {}
>(({ className, ...props }, ref) => (
  <NavLink to={GitBookLink['ContactUs']} className={className} target="_blank">
    <Lottie
      ref={ref}
      {...props}
      className={cn(
        'w-16 overflow-hidden rounded-full border border-primary p-2.5',
        'conver-sation cursor-pointer',
        'hover:shadow-[0_0_50px_0px_hsl(var(--primary)/0.5)]'
      )}
      loop
      animationData={conversation}
    />
  </NavLink>
))

export const HowItWorks = React.forwardRef<
  React.ComponentRef<typeof Lottie>,
  Omit<LottieComponentProps, 'animationData'> & {
    pathname: string
  }
>(({ className, pathname, ...props }, ref) => {
  const { t } = useTranslation()
  const links = {
    [RoutePath.AIRDROP]: GitBookLink.MegaAirdropEvent,
    [RoutePath.MINING_PLATFORM]: GitBookLink.MiningPointForDualPlatformUsers,
    [RoutePath.MINING_INFLUENCE]: GitBookLink.InfluenceMiningEvent,
    [RoutePath.DAO]: GitBookLink.LiquidityCoCreationEvent
  }

  return (
    <NavLink
      to={links[pathname as keyof typeof links]}
      className={className}
      target="_blank"
    >
      <Tooltip
        triggerProps={{
          children: (
            <Lottie
              ref={ref}
              {...props}
              className={cn(
                'w-16 overflow-hidden rounded-full border border-primary p-2.5',
                'conver-sation cursor-pointer',
                'hover:shadow-[0_0_50px_0px_hsl(var(--primary)/0.5)]'
              )}
              loop
              animationData={howitworks}
            />
          )
        }}
      >
        <Flex className="items-center gap-1 text-base">
          <IconTooltip className="size-5 text-primary" />
          {t('contacts.gitbook.howItWorks')}
        </Flex>
      </Tooltip>
    </NavLink>
  )
})

export const LogoLottie = React.forwardRef<
  React.ComponentRef<typeof Lottie>,
  Omit<LottieComponentProps, 'animationData'> & {}
>(({ className, ...props }, ref) => (
  <Lottie
    ref={ref}
    {...props}
    className={cn('w-[144px] xl:w-[170px]', className)}
    loop
    animationData={betsol}
  />
))
